import {useDev, useAxios, AxiosErrorDataModel} from '@sttedra_ui/framework';
import LayerApiModel from './layer.api-model';

/**
 * @typedef {import("@sttedra_ui/framework").AxiosErrorDataModel} AxiosErrorDataModel
 */

// #region Globals
const CONTEXT_BASE_PATH = 'Layer';
const {base} = useAxios();
// #endregion


// #region Public functions
async function getLayersForVisor() {
  try {
    const url = `/${CONTEXT_BASE_PATH}/ForVisor`;

    const {data} = await base
      .get(url, {
        timeout: 5000,
      });
    return data.map((mapBase) => new LayerApiModel(mapBase));
  } catch (err) {
    return catchError(err);
  }
}

// #endregion


// #region Private functions
/**
 *
 * @param {AxiosErrorDataModel} errorModel
 * @returns
 */
function catchError(errorModel) {
  if (!(errorModel instanceof AxiosErrorDataModel)) {
    throw new Error(errorModel);
  }

  useDev.error(
    errorModel.errors
      .reduce((acc, e) => acc + `(${e.code}) ${e.type}: ${e.message}`,
        `[example.api] Errors:\n`),
  );
}
// #endregion

export {
  getLayersForVisor,
};
